'use strict';
var regexpExec = require('./_regexp-exec');
require('./_export')({
  target: 'RegExp',
  proto: true,
  forced: regexpExec !== /./.exec
}, {
  exec: regexpExec
});



//////////////////
// WEBPACK FOOTER
// D:/ENI Project/Trunk/AngularSourceCode/ENI.BalanceBenefits.WebPortal/~/core-js/modules/es6.regexp.exec.js
// module id = ../../../../core-js/modules/es6.regexp.exec.js
// module chunks = 2